import { DETAIL_TRANSACTIONS_YUNO, DETAIL_TRANSACTIONS_YUNO_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const detailYunoAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/reports/transaction-yuno/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_TRANSACTIONS_YUNO,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_TRANSACTIONS_YUNO_ERROR,
      response: e || {},
    });
  }
};
